var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMyWalletEarningIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    fill: "none",
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9D4300",
    d: "M24.156 1.266a.78.78 0 00-.422-.422.781.781 0 00-.297-.063h-3.125a.781.781 0 100 1.563h1.243l-1.063 1.062-3.508 4.211-4.132-2.062a.781.781 0 00-.907.148l-4.21 4.25-3.43-2.031a.781.781 0 00-.828 0L1.133 9.484a.781.781 0 00.86 1.297l1.913-1.265 3.531 2.093a.83.83 0 00.399.11.783.783 0 00.555-.235l4.265-4.28 4.18 2.085a.781.781 0 00.953-.195l3.86-4.633 1.007-1.016v1.243a.781.781 0 001.563 0V1.563a.781.781 0 00-.063-.297zM6.25 16.406H1.562a.781.781 0 00-.78.782v2.343h6.25v-2.343a.781.781 0 00-.782-.782zM.781 23.438a.781.781 0 00.781.78H6.25a.781.781 0 00.781-.78v-2.344H.781v2.343zM14.844 13.28h-4.688a.781.781 0 00-.781.781v2.344h6.25v-2.343a.781.781 0 00-.781-.782zM9.375 23.437a.781.781 0 00.781.782h4.688a.781.781 0 00.781-.782v-2.343h-6.25v2.343z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyWalletEarningIcon);
export default __webpack_public_path__ + "static/media/myWalletEarningIcon.0dd3720038bd113b831adcc9255e1f83.svg";
export { ForwardRef as ReactComponent };